// extracted by mini-css-extract-plugin
export var root = "iVus";
export var rootCol = "+Zrg";
export var rootIcon = "_0g6w";
export var rootIconWrapper = "_0UxS";
export var rootImage = "thqE";
export var rootItems = "o98Y";
export var rootPicture = "_4lpG";